// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"eb4430ac","410":"b1a17744","453":"63a79b0d"}[chunkId] + ".chunk.js";
};